import './App.css';
import CalculatorPage from './components/investment/CalculatorPage';

function App() {
  return (
    <div className="App">
      {<CalculatorPage />}
    </div>
  );
}

export default App;
